import { ROUTES } from '../../../routes/path'

export const NavItems = [
  { label: 'Início', value: ROUTES.home },
  { label: 'Projetos Executados', value: ROUTES.project },
  { label: 'Negócios Apoiados', value: ROUTES.business },
  { label: 'Impactos da Semente', value: ROUTES.impact },
  { label: 'Equipe Semente', value: ROUTES.team }
]
